  (function () {
    const assetScript = document.currentScript;
    const sectionId = assetScript ? (assetScript.dataset.sectionId || '') : '';
    const targetSectionId = 'template--26566778683639__1734811475e51f0284';
    const targetShopifyWrapperId = 'shopify-section-' + targetSectionId;
    const slotId = 'DgMobileRelocatedSection-' + sectionId;
    const originMarkerId = 'DgMobileRelocatedSectionOrigin-' + targetSectionId;
    const registryKey = targetSectionId + '::' + sectionId;
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    window.__dgMobileSectionRelocators = window.__dgMobileSectionRelocators || {};

    /* If Shopify reloads this product section in the theme editor, reuse the
       existing listeners and simply ask the original relocator to run again. */
    if (window.__dgMobileSectionRelocators[registryKey]) {
      window.__dgMobileSectionRelocators[registryKey]();
      return;
    }

    let animationFrame = null;

    function findTargetSection() {
      return (
        document.getElementById(targetShopifyWrapperId) ||
        document.getElementById(targetSectionId)
      );
    }

    function findDestinationSlot() {
      return document.getElementById(slotId);
    }

    function getOrCreateOriginMarker(targetSection) {
      let marker = document.getElementById(originMarkerId);
      if (marker) return marker;

      if (!targetSection || !targetSection.parentNode) return null;

      marker = document.createElement('span');
      marker.id = originMarkerId;
      marker.hidden = true;
      marker.setAttribute('aria-hidden', 'true');
      marker.setAttribute('data-dg-mobile-section-origin', targetSectionId);

      targetSection.parentNode.insertBefore(marker, targetSection);
      return marker;
    }

    function moveSectionForCurrentViewport() {
      animationFrame = null;

      const targetSection = findTargetSection();
      const destinationSlot = findDestinationSlot();

      if (!targetSection || !destinationSlot) return;

      if (mobileQuery.matches) {
        /* Save the exact desktop/original position before moving anything. */
        getOrCreateOriginMarker(targetSection);

        if (targetSection.parentNode !== destinationSlot) {
          destinationSlot.appendChild(targetSection);
        }

        targetSection.setAttribute('data-dg-mobile-relocated', 'true');
        return;
      }

      /* Desktop: put the section back exactly where Shopify originally rendered it. */
      const originMarker = document.getElementById(originMarkerId);

      if (originMarker && originMarker.parentNode) {
        if (
          targetSection.parentNode !== originMarker.parentNode ||
          targetSection.previousSibling !== originMarker
        ) {
          originMarker.parentNode.insertBefore(targetSection, originMarker.nextSibling);
        }
      }

      targetSection.removeAttribute('data-dg-mobile-relocated');
    }

    function scheduleRelocation() {
      if (animationFrame !== null) {
        cancelAnimationFrame(animationFrame);
      }

      animationFrame = requestAnimationFrame(moveSectionForCurrentViewport);
    }

    function initialiseRelocator() {
      scheduleRelocation();

      window.addEventListener('load', scheduleRelocation, { passive: true });
      window.addEventListener('resize', scheduleRelocation, { passive: true });
      window.addEventListener('orientationchange', scheduleRelocation, { passive: true });
      mobileQuery.addEventListener?.('change', scheduleRelocation);

      /* Keep it working inside Shopify's theme editor too. */
      document.addEventListener('shopify:section:load', scheduleRelocation);
      document.addEventListener('shopify:section:reorder', scheduleRelocation);
      document.addEventListener('shopify:section:select', scheduleRelocation);
    }

    window.__dgMobileSectionRelocators[registryKey] = scheduleRelocation;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseRelocator, { once: true });
    } else {
      initialiseRelocator();
    }
  })();
